import { Line } from 'vue-chartjs';
export default {
    extends: Line,

    props: ['chartdataLabels', 'chartdataSets', 'options'],

    data() {
        return {
            chartdata: {
                labels: this.chartdataLabels,
                datasets: this.chartdataSets,
            },
            defaultOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            id: 'y-axis-hours',
                            type: 'linear',
                            position: 'right',
                            ticks: {
                                min: 0,
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Elapsed Time (Hrs)'
                            },
                            gridLines: {
                                drawOnChartArea: false
                            }
                        },
                        {
                            id: 'y-axis-time',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                // Time represented as hours from midnight (e.g. 8.5 for 8:30 AM)
                                min: 0,
                                max: 24,
                                stepSize: 2,
                                callback: function(value) {
                                    if (value === 0 || value === 24) return '12 AM';
                                    if (value === 12) return '12 PM';
                                    if (value < 12) return value + ' AM';
                                    return (value - 12) + ' PM';
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Clock In Time'
                            }
                        }
                    ],
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            const dataset = data.datasets[tooltipItem.datasetIndex];
                            const index = tooltipItem.index;
                            let label = dataset.label || '';
                            if (label) {
                                label += ': ';
                            }

                            if (dataset.yAxisID === 'y-axis-time') {
                                const val = tooltipItem.yLabel;
                                const hours = Math.floor(val);
                                const minutes = Math.round((val - hours) * 60);
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                const h = hours % 12 || 12;
                                const m = minutes < 10 ? '0' + minutes : minutes;
                                label += h + ':' + m + ' ' + ampm;
                            } else {
                                label += tooltipItem.yLabel;
                            }

                            if (dataset.statuses && dataset.statuses[index]) {
                                label += ' (' + dataset.statuses[index] + ')';
                            }

                            return label;
                        }
                    }
                }
            },
        };
    },

    mounted() {
        this.render();
    },
    methods: {
        render() {
            if (this.chartdata.datasets && this.chartdata.labels) {
                this.renderChart(this.chartdata, this.options || this.defaultOptions);
            }
        }
    },
    watch: {
        chartdataSets: {
            handler(val) {
                this.chartdata.datasets = val;
                this.render();
            },
            deep: true
        },
        chartdataLabels(val) {
            this.chartdata.labels = val;
            this.render();
        },
    },
};
